export class Card {

    constructor($element, id, selectHandler) {
        this.$element = $element;
        this.active = false;

        // Grab DOM elements
        this.$trigger = $element.querySelector('a');
        var href = this.$trigger.getAttribute('href');

        // Body and content
        this.$body = document.getElementById(href.substr(1));
        this.$content = this.$body.querySelector('.card-content');

        // Expander
        this.$expander = $element.childNodes[0].childNodes[0];

        // Listeners
        this.$trigger.addEventListener('click', function (event) {
            event.preventDefault();
            selectHandler(id);
        });
    };

    show() {
        this.$element.classList.add('active');

        setTimeout(() => {
            const rect = this.$content.getBoundingClientRect();
            this.$body.style.height = `${rect.height + 30}px`;
            this.active = true;
            this.transitioning = false;
        }, 50);

        this.transitioning = true;
    };

    collapse() {
        this.$body.style.height = 0;
        this.$expander.classList.add('closing');
    
        setTimeout(() => {
            this.$element.classList.remove('active');
            this.$expander.classList.remove('closing');
            this.transitioning = false;
            this.active = false;
        }, 350);

        this.transitioning = true;
    };

}